var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getRebornUrl } from '@/shared/utils/helpers';
let SearchReborn = class SearchReborn extends Vue {
    constructor() {
        super(...arguments);
        this.retryTimers = [];
        // Polling de token — ativo apenas durante recuperação de sessão
        this.tokenPollTimer = null;
        // Último token enviado — detecta quando o login atualiza o token
        this.lastSentToken = '';
    }
    /** URL do iframe — sem token na URL; o token é enviado via postMessage SEARCH_INIT.
     *  Quando a rota traz :cnpj (deep-link de empresa aberto em nova guia pelo React),
     *  encaminha ?cnpj= para o iframe, que abre o drawer daquela empresa. */
    get iframeSrc() {
        const params = this.$route.params;
        const searchId = params.searchId || '';
        const cnpj = params.cnpj || '';
        const base = `${getRebornUrl()}/search`;
        if (!searchId)
            return base;
        const query = new URLSearchParams({ searchId });
        if (cnpj)
            query.set('cnpj', cnpj);
        return `${base}?${query.toString()}`;
    }
    /**
     * Envia o token atual para o iframe React via postMessage.
     *
     * As feature flags da conta vão junto: o shell já as tem (GET user/me) e é
     * por elas que o reborn liga funcionalidades do detalhe da empresa aberto
     * na busca (WhatsApp do decisor, validação de e-mails).
     */
    sendInit() {
        const iframe = this.$refs.iframe;
        if (!iframe || !iframe.contentWindow)
            return;
        const token = localStorage.getItem('auth_token_default') || '';
        this.lastSentToken = token;
        // @ts-ignore TS2349: $auth injetado pelo vue-auth
        const user = this.$auth.user() || {};
        iframe.contentWindow.postMessage({
            type: 'SEARCH_INIT',
            token,
            features: Array.isArray(user.features) ? user.features : [],
        }, '*');
    }
    /** Chamado quando o iframe termina de carregar — inicia o handshake. */
    onIframeLoad() {
        this.stopSessionRecovery();
        this.sendInit();
        // Retentativas para cobrir race condition entre @load e o React estar pronto
        this.retryTimers.push(setTimeout(() => this.sendInit(), 500));
        this.retryTimers.push(setTimeout(() => this.sendInit(), 2000));
    }
    /**
     * Inicia a recuperação de sessão após receber SESSION_EXPIRED do iframe.
     * Envia o token atual imediatamente e começa a monitorar localStorage para
     * detectar quando o usuário fizer login e o token for atualizado.
     */
    startSessionRecovery() {
        if (this.tokenPollTimer)
            return; // já em progresso
        // Envia o token atual (pode ainda estar expirado — React tentará e falhará,
        // mas ficará aguardando um SEARCH_INIT com token válido).
        this.sendInit();
        // Monitora auth_token_default a cada 500 ms; quando mudar, envia novo token.
        this.tokenPollTimer = setInterval(() => {
            const current = localStorage.getItem('auth_token_default') || '';
            if (current && current !== this.lastSentToken) {
                this.sendInit();
                this.stopSessionRecovery();
            }
        }, 500);
        // Para o polling automaticamente após 10 minutos para não vazar memória.
        this.retryTimers.push(setTimeout(() => this.stopSessionRecovery(), 10 * 60 * 1000));
    }
    stopSessionRecovery() {
        if (this.tokenPollTimer) {
            clearInterval(this.tokenPollTimer);
            this.tokenPollTimer = null;
        }
    }
    /** Ouve postMessages do iframe React. */
    handleMessage(event) {
        if (!event.data)
            return;
        // React sinaliza que está pronto para receber o token
        if (event.data.type === 'IFRAME_READY') {
            this.sendInit();
            return;
        }
        // React detectou 401/403 — inicia recuperação aguardando novo login
        if (event.data.type === 'SESSION_EXPIRED') {
            this.startSessionRecovery();
            return;
        }
        // Nova busca no React — reflete o id na URL para o link ser compartilhável.
        if (event.data.type === 'SEARCH_ID_CHANGED') {
            this.syncSearchIdInUrl(event.data.searchId);
            return;
        }
    }
    /**
     * Escreve /search/:searchId na barra de endereços sem passar pelo router.
     * Usar $router aqui recomputaria `iframeSrc` (que lê $route.params.searchId),
     * trocando o `src` do iframe e remontando o React no meio da busca.
     */
    syncSearchIdInUrl(searchId) {
        if (!searchId)
            return;
        const target = `/search/${encodeURIComponent(searchId)}`;
        if (window.location.pathname === target)
            return;
        window.history.replaceState(window.history.state, '', target);
    }
    mounted() {
        window.addEventListener('message', this.handleMessage);
    }
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
        this.stopSessionRecovery();
        this.retryTimers.forEach(clearTimeout);
        this.retryTimers = [];
    }
};
SearchReborn = __decorate([
    Component({ name: 'SearchReborn' })
], SearchReborn);
export default SearchReborn;
